// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__3ZXSo","approved":"Status_approved__2Eb9w","rejected":"Status_rejected__AStRR","expired":"Status_expired__2D9sx","label":"Status_label__31qoC"};